import { Component, forwardRef, Injector } from '@angular/core';
import { IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-r-rate',
  templateUrl: './r-rate.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RRateComponent),
      multi: true
    }
  ]
})
export class RRateComponent extends RenderComponentBase {
  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {}
  static KEY = 'r-d-rate';
}
